import { useMemo, useState } from "react";
import AddPaymentModal from "./add-payment.modal";
import PaymentsModal from "./payments.modal";
import { UtilsService } from "../../services/utils";
import { RegistersService } from "../../services/operation/registers";

function Step3({ corte, prev }: any) {
  const [$corte, setCorte] = useState(corte);

  const [showModalPayments, setShowModalPayments] = useState<any>({
    show: false,
    data: null,
  });
  const [showModalAddPayment, setShowModalAddPayment] = useState<any>({
    show: false,
    data: null,
  });

  const totalPending = useMemo(() => {

    return $corte.customers
      .map((customer: any) => {
        const total = customer.valor_total;
        const paid = customer.pagos.reduce(( a: number, b: any) => a + b.monto, 0)

        return paid < total
      })
      .filter((status: boolean) => status)
      .length;
    
  }, [$corte]);

  const totalPaid = (customer: any) => {
    const paid = customer.pagos.reduce(( a: number, b: any) => a + b.monto, 0);

    return paid;
  }

  const isPaid = (customer: any) => {
    const total = customer.valor_total;

    const paid = customer.pagos.reduce(( a: number, b: any) => a + b.monto, 0);

    return paid >= total ? <span className="badge badge-success">Liquidado</span> : <span className="badge badge-danger">Pendiente de liquidar</span>;
  }

  const handlePaymentModal = async () => {
    const response = await RegistersService.getOne(corte._id);
    setCorte(response);
    setShowModalAddPayment({ show: false, data: null })
  }

  return (
    <>
      <div className="mb-5">
        <h2 className="fw-bold d-flex align-items-center text-gray-900">
          Pagos
        </h2>
        <div className="text-muted fw-semibold fs-6">
          En esta sección se registran los depósitos que realizan los
          empaques/acopios por la fruta vendida. Pueden ser varios pagos, hasta
          sumar al valor total de la fruta o un pago que cubra el total.
        </div>
      </div>

      {totalPending > 0 && (
        <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-12 p-6">
          <i className="ki-duotone ki-information fs-2tx text-warning me-4">
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </i>

          <div className="d-flex flex-stack flex-grow-1">
            <div className="fw-semibold">
              <h4 className="text-gray-900 fw-bold">Corte sin liquidar</h4>
              <div className="fs-6 text-gray-700">
                Hay {totalPending} proveedor{totalPending > 1 ? "es" : ""} por
                recibir el pago total de la fruta. Puedes registrar estos pagos
                desde esta sección
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-hover table-rounded table-striped border gy-7 gs-7">
          <thead>
            <tr className="fw-semibold fs-6 text-gray-800 border-bottom-2 border-gray-200">
              <th>Productor</th>
              <th>Huerta</th>
              <th>Cajas</th>
              <th>Peso x caja</th>
              <th>Kg totales</th>
              <th>Valor total</th>
              <th>Fruta pagada</th>
              <th className="text-center">Estatus</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {$corte.customers.map((customer: any) => (
              <tr key={customer._id}>
                <td className="align-middle">{customer.customer.name}</td>
                <td className="align-middle">{customer.field.name}</td>
                <td className="align-middle text-nowrap">{customer.cajas}</td>
                <td className="align-middle text-nowrap">
                  {customer.peso_caja}
                </td>
                <td className="align-middle text-nowrap">
                  {customer.kg_totales}
                </td>
                <td className="align-middle text-nowrap">
                  ${UtilsService.numberFormat(customer.valor_total)}
                </td>
                <td className="align-middle text-nowrap">
                  ${UtilsService.numberFormat(totalPaid(customer))}
                </td>
                <td className="align-middle text-center">{isPaid(customer)}</td>
                <td className="align-middle text-center">
                  <button
                    className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                    data-kt-menu-placement="bottom-end"
                    data-kt-menu-trigger="click"
                  >
                    Depósitos
                    <i className="ki-duotone ki-down fs-5 ms-1" />
                  </button>
                  <div
                    className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                    data-kt-menu="true"
                  >
                    <div className="menu-item px-3">
                      <button
                        className="menu-link px-3 border-0 bg-white fw-semibold  fs-7"
                        onClick={() =>
                          setShowModalPayments({
                            show: true,
                            data: { customer },
                          })
                        }
                      >
                        Consultar
                      </button>
                    </div>
                    <div className="menu-item px-3">
                      <button
                        className="menu-link px-3 border-0 bg-white fw-semibold  fs-7"
                        onClick={() =>
                          setShowModalAddPayment({
                            show: true,
                            data: { customer },
                          })
                        }
                      >
                        Agregar
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="mt-8">
          <div className="">
            <button
              className="btn btn-lg btn-light-primary me-3"
              type="button"
              onClick={prev}
            >
              <i className="ki-duotone ki-arrow-left fs-4 me-1">
                <span className="path1" />
                <span className="path2" />
              </i>
              Regresar
            </button>
          </div>
        </div>
      </div>

      <PaymentsModal
        show={showModalPayments.show}
        data={showModalPayments.data}
        setShow={() => setShowModalPayments({ show: false, data: null })}
      />
      <AddPaymentModal
        show={showModalAddPayment.show}
        data={showModalAddPayment.data}
        setShow={handlePaymentModal}
      />
    </>
  );
}

export default Step3;
